<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.334 12.667a4.667 4.667 0 100-9.333 4.667 4.667 0 000 9.333zm-4 2a4.667 4.667 0 00-4.667 4.667v5.667a1 1 0 001 1h12.789A7.988 7.988 0 0116 23.334a7.99 7.99 0 013.294-6.47 4.663 4.663 0 00-3.96-2.197h-8zM24 18a1 1 0 00-1 1v3.334h-3.333a1 1 0 100 2H23v3.333a1 1 0 102 0v-3.333h3.334a1 1 0 000-2H25v-3.333a1 1 0 00-1-1z"/></svg>
</template>

<script>
export default {
  name: 'userPersonAddFilled'
}
</script>
